"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[412],{

/***/ 38825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ add_wishlist_button; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AddWishlistButton/add-wishlist-button.styles.js




const ButtonContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* BaseButton */.Yd)``;
const FilledIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Heart */.Xdw).attrs(props => Object.assign({
  color: '#db44a7'
}, props))`
  width: ${({
  width
}) => `${width}px`};
  height: ${({
  height
}) => `${height}px`};

  animation: ${utils/* scaleUpCenter */.az} 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
`;
const EmptyIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Heart */.Xdw).attrs(props => Object.assign({
  color: 'transparent',
  stroke: 'darkGray'
}, props))`
  width: ${({
  width
}) => `${width}px`};
  height: ${({
  height
}) => `${height}px`};

  animation: ${utils/* scaleUpCenter */.az} 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AddWishlistButton/add-wishlist-button.js






function AddWishlistButton(_ref) {
  let {
    active,
    onClick,
    width,
    height
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["active", "onClick", "width", "height"]);

  return /*#__PURE__*/react.createElement(ButtonContainer, (0,esm_extends/* default */.Z)({
    "data-testid": "add-wishlist-button",
    onClick: onClick
  }, props), active ? /*#__PURE__*/react.createElement(FilledIcon, {
    "data-testid": "filled-icon",
    width: width,
    height: height
  }) : /*#__PURE__*/react.createElement(EmptyIcon, {
    "data-testid": "empty-icon",
    width: width,
    height: height
  }));
}

AddWishlistButton.defaultProps = {
  active: false,
  width: 20,
  height: 20
};
 false ? 0 : void 0;
/* harmony default export */ var add_wishlist_button = (AddWishlistButton);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AddWishlistButton/index.js


/***/ }),

/***/ 33309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* reexport */ Alert_useAlert; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Alert/alert.styles.js


const Container = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;
const Message = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  margin-bottom: 20px;
  font-size: 14px;
`;
const OKButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx)`
  font-size: 12px;
  text-transform: uppercase;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Alert/alert.js





function Alert({
  title,
  message,
  showDialog,
  onClickOutside
}) {
  return /*#__PURE__*/react.createElement(Dialog/* default */.Z, {
    type: "alert",
    position: "center",
    showClose: false,
    visible: showDialog,
    onClickOutside: onClickOutside,
    portal: true
  }, /*#__PURE__*/react.createElement(Container, null, /*#__PURE__*/react.createElement(Title, null, title), /*#__PURE__*/react.createElement(Message, null, message), /*#__PURE__*/react.createElement(OKButton, {
    full: true,
    onClick: onClickOutside
  }, "Entendi")));
}

 false ? 0 : void 0;
/* harmony default export */ var Alert_alert = (Alert);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Alert/useAlert.js



const useAlert = () => {
  const [aTitle, setTitle] = (0,react.useState)('');
  const [aMessage, setMessage] = (0,react.useState)('');
  const [showDialog, setShowDialog] = (0,react.useState)(false);

  const showAlertMessage = ({
    title = 'Atenção',
    message
  }) => {
    setTitle(title);
    setMessage(message);
    setShowDialog(true);
  };

  const Alert = () => /*#__PURE__*/react.createElement(react.Fragment, null, showDialog && /*#__PURE__*/react.createElement(Alert_alert, {
    title: aTitle,
    message: aMessage,
    showDialog: showDialog,
    onClickOutside: () => setShowDialog(false),
    width: "300px"
  }));

  return {
    showAlertMessage,
    Alert
  };
};

/* harmony default export */ var Alert_useAlert = (useAlert);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Alert/index.js


/***/ }),

/***/ 52337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ alert_text; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AlertText/alert-text.styles.js




const Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  width: 100%;
  background: ${props => (0,build_esm/* getAlertColor */.UX)(`${props.intent}.base`)(props)};
`;
const Message = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  display: flex;
  align-items: center;
  padding: 10px;
  gap: ${props => (0,build_esm/* themeGet */.R)('space.2')(props)}px;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  color: ${props => (0,build_esm/* getAlertColor */.UX)(`${props.intent}.text`)(props)};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AlertText/alert-text.js





function AlertText({
  message,
  intent,
  icon,
  styleContainer,
  styleMessage
}) {
  const renderIcon = messageIcon => {
    if (typeof messageIcon !== 'string') return icon;
    return /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      color: (styleMessage == null ? void 0 : styleMessage.color) || `alert.${intent}.text`,
      name: messageIcon,
      "data-testid": "alert-icon"
    });
  };

  const renderMessage = messageContent => {
    const messageIcon = (messageContent == null ? void 0 : messageContent.icon) || icon;
    return /*#__PURE__*/react.createElement(react.Fragment, null, messageIcon && renderIcon(messageIcon), typeof messageContent === 'string' ? messageContent : (messageContent == null ? void 0 : messageContent.text) || messageContent);
  };

  return /*#__PURE__*/react.createElement(Container, {
    intent: intent,
    "data-testid": "alert-container",
    style: styleContainer
  }, Array.isArray(message) ? message.map((text, index) => /*#__PURE__*/react.createElement(Message, {
    key: `alert-message-${index}`,
    intent: intent,
    "data-testid": "alert-text",
    style: styleMessage
  }, renderMessage(text))) : /*#__PURE__*/react.createElement(Message, {
    intent: intent,
    "data-testid": "alert-text",
    style: styleMessage
  }, renderMessage(message)));
}

AlertText.defaultProps = {
  message: '',
  intent: 'info',
  icon: null,
  styleContainer: {},
  styleMessage: {}
};
 false ? 0 : void 0;
/* harmony default export */ var alert_text = (AlertText);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AlertText/index.js


/***/ }),

/***/ 77954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ attribute; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeBase/index.js + 2 modules
var AttributeBase = __webpack_require__(34014);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeRadio/index.js + 2 modules
var AttributeRadio = __webpack_require__(7069);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AlertText/index.js + 2 modules
var AlertText = __webpack_require__(52337);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Attribute/WarningText/WarningText.js





const WarningText = ({
  showAlert,
  message,
  icon,
  alignment
}) => {
  if (showAlert) return /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    width: "100%",
    justifyContent: alignment
  }, /*#__PURE__*/react.createElement(AlertText/* default */.Z, {
    "data-testid": "warning-text",
    message: message,
    intent: "warning",
    icon: icon,
    styleContainer: {
      maxWidth: 'max-content'
    }
  }));
  return null;
};

WarningText.defaultProps = {
  showAlert: false,
  message: '',
  icon: '',
  alignment: 'center'
};
 false ? 0 : void 0;
/* harmony default export */ var WarningText_WarningText = (WarningText);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Attribute/WarningText/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Attribute/attribute.js








const Attribute = ({
  attribute,
  variations,
  onChange,
  alignment,
  showWarningText,
  warningMessage,
  iconWarningText
}) => {
  var _attribute$values;

  return /*#__PURE__*/react.createElement(AttributeBase/* default */.Z, (0,esm_extends/* default */.Z)({}, attribute, {
    alignment: alignment
  }), attribute == null ? void 0 : (_attribute$values = attribute.values) == null ? void 0 : _attribute$values.map((value, index) => {
    const variation = (0,utils/* getVariation */.KF)(variations, value);
    return /*#__PURE__*/react.createElement(AttributeRadio/* default */.Z, {
      key: `${value}-${index}`,
      value: value,
      type: attribute == null ? void 0 : attribute.type,
      checked: (attribute == null ? void 0 : attribute.selected) && (attribute == null ? void 0 : attribute.current) === value,
      disabled: !(variation != null && variation.isAvailable) && !(variation != null && variation.available),
      onChange: onChange
    }, value);
  }), /*#__PURE__*/react.createElement(WarningText_WarningText, {
    showAlert: showWarningText,
    message: warningMessage,
    icon: iconWarningText,
    alignment: alignment
  }));
};

Attribute.defaultProps = {
  attribute: {},
  variations: [],
  alignment: '',
  showWarningText: false,
  warningMessage: '',
  iconWarningText: ''
};
 false ? 0 : void 0;
/* harmony default export */ var attribute = (Attribute);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Attribute/index.js


/***/ }),

/***/ 34014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ attribute_base; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeBase/attribute-base.styles.js




const labelAlignment = {
  start: 'left',
  end: 'right',
  center: 'center'
};
const Container = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;
`;
const Label = styled_components_browser_esm/* default.div */.ZP.div`
  width: 100%;
  color: ${(0,build_esm/* getTextColor */.uu)('attributeLabel')};
  text-align: ${({
  bordered,
  alignment
}) => bordered ? 'left' : labelAlignment[alignment]};
  margin-top: 8px;
  margin-bottom: 8px;
  ${_ref => {
  let {
    bordered
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["bordered"]);

  return bordered && styled_components_browser_esm/* css */.iv`
      display: flex;
      justify-content: space-between;
      padding: 15px;
      background-color: ${(0,build_esm/* getBackgroundColor */.dF)('white')(props)};
      border-radius: 6px;
      border-width: 1px;
      border-style: solid;
      border-color: ${(0,build_esm/* getBorderColor */.kJ)('light')(props)};

      ${(0,build_esm/* getMediaQuery */.aK)('large')} {
        cursor: pointer;
      }
    `;
}}

  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    svg {
      transform: rotate(90deg);
    }
  }
`;
const AttributeList = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(({
  alignment,
  gap
}) => ({
  justifyContent: alignment,
  rowGap: 2,
  columnGap: gap || 2
}))`
  flex-flow: row wrap;

  ${({
  smoothable
}) => smoothable && styled_components_browser_esm/* css */.iv`
      overflow: hidden;
      height: 105px;
    `};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeBase/attribute-base.js






const AttributeBase = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    children,
    label,
    current,
    selected,
    bordered,
    onClick,
    onBlur,
    alignment,
    smoothable,
    showTitle
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "label", "current", "selected", "bordered", "onClick", "onBlur", "alignment", "smoothable", "showTitle"]);

  return /*#__PURE__*/react.createElement(Container, {
    ref: ref,
    onBlur: onBlur,
    tabIndex: 1,
    "data-testid": "attribute-container"
  }, showTitle ? /*#__PURE__*/react.createElement(Label, {
    bordered: bordered,
    alignment: alignment,
    onClick: onClick,
    "data-testid": "attribute-label"
  }, !selected ? `Selecionar ${label}` : /*#__PURE__*/react.createElement("span", null, label, ": ", /*#__PURE__*/react.createElement("strong", null, current)), bordered && /*#__PURE__*/react.createElement(esm/* ArrowRight */.olP, {
    width: 8,
    height: 12
  })) : null, /*#__PURE__*/react.createElement(AttributeList, (0,esm_extends/* default */.Z)({
    alignment: alignment,
    smoothable: smoothable
  }, props), children));
});
AttributeBase.defaultProps = {
  label: '',
  current: '',
  selected: false,
  bordered: false,
  alignment: 'center',
  smoothable: false,
  showTitle: true
};
 false ? 0 : void 0;
AttributeBase.displayName = 'AttributeBase';
/* harmony default export */ var attribute_base = (AttributeBase);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeBase/index.js


/***/ }),

/***/ 5086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ attribute_color; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeBase/index.js + 2 modules
var AttributeBase = __webpack_require__(34014);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeRadio/index.js + 2 modules
var AttributeRadio = __webpack_require__(7069);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeColor/attribute-color.styles.js



const Buttoned = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({}, props))`
  ${({
  shouldHover
}) => shouldHover && styled_components_browser_esm/* css */.iv`
      &:hover {
        border-color: ${(0,build_esm/* getBackgroundColor */.dF)('primary')};
      }
    `}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeColor/attribute-color.js












const Smoothable = ({
  onClick,
  show
}) => {
  return show && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    "data-testid": "attribute-color-more",
    position: "absolute",
    justifyContent: "center",
    background: "linear-gradient(0deg, #ffffff, transparent 80%)",
    color: "text.primary",
    fontWeight: "bold",
    cursor: "pointer",
    width: 1,
    bottom: 0,
    height: 36,
    padding: 1,
    onClick: onClick
  }, "ver mais cores");
};

 false ? 0 : void 0;

const Buttonable = ({
  attributesLength,
  onClick,
  show,
  style
}) => {
  return show && /*#__PURE__*/react.createElement(Buttoned, (0,esm_extends/* default */.Z)({
    "data-testid": "attribute-color-more",
    fontSize: 4,
    borderRadius: "default",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderWidth: 1,
    borderColor: "#e5e5e5",
    borderStyle: "solid",
    onClick: onClick
  }, style), "+ ", attributesLength);
};

 false ? 0 : void 0;
const componentVariants = {
  smooth: Smoothable,
  button: Buttonable
};

const AttributeColor = _ref => {
  let {
    attribute,
    variations,
    onChange,
    onVariationClick,
    title,
    alignment,
    minLength,
    variant,
    showTitle,
    style
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["attribute", "variations", "onChange", "onVariationClick", "title", "alignment", "minLength", "variant", "showTitle", "style"]);

  const verifiedVariant = ['smooth', 'button'].includes(variant) ? variant : 'smooth';
  const ShowMoreComponent = componentVariants == null ? void 0 : componentVariants[verifiedVariant];
  const [smoothable, setSmoothable] = (0,react.useState)(verifiedVariant === 'smooth');
  const [buttonable, setbuttonable] = (0,react.useState)(verifiedVariant === 'button');
  const [attrValues, setAttrValues] = (0,react.useState)([]);
  const sorted = (0,utils/* sortByAvailable */.hY)(attribute)(variations);
  const sortedValues = (0,react.useMemo)(() => {
    var _sortBySelected;

    const values = sorted.reduce((acc, value) => [...acc, Object.assign({}, (0,utils/* getVariation */.KF)(variations, value), {
      selected: buttonable && (attribute == null ? void 0 : attribute.selected) && (attribute == null ? void 0 : attribute.current) === value
    })], []);
    return (_sortBySelected = (0,utils/* sortBySelected */.gf)(values)) == null ? void 0 : _sortBySelected.map(variation => variation.value);
  }, [attribute, variations]);
  const hasShowMore = (0,react.useMemo)(() => {
    return sortedValues.length > minLength;
  }, []);
  (0,react.useEffect)(() => {
    if (sortedValues.length > minLength && verifiedVariant === 'button') {
      return setAttrValues(sortedValues.slice(0, minLength - 1));
    }

    return setAttrValues(sorted);
  }, [sortedValues]);

  const handleOnClick = () => {
    if (smoothable) {
      return setSmoothable(!smoothable);
    }

    setbuttonable(!buttonable);
    return setAttrValues(attrValues);
  };

  return /*#__PURE__*/react.createElement(AttributeBase/* default */.Z, (0,esm_extends/* default */.Z)({}, attribute, {
    smoothable: hasShowMore && smoothable,
    alignment: alignment,
    showTitle: showTitle
  }, props), attrValues == null ? void 0 : attrValues.map((value, index) => {
    const {
      image,
      path
    } = (0,utils/* getVariation */.KF)(variations, value) || {};
    const availability = (0,utils/* getAvailability */.lm)(variations, value);
    return /*#__PURE__*/react.createElement(AttributeRadio/* default */.Z, {
      key: `${value}-${index}`,
      value: value,
      type: attribute.type,
      path: path,
      checked: attribute.selected && attribute.current === value,
      disabled: !availability,
      onChange: onChange,
      onVariationClick: onVariationClick,
      style: style
    }, image ? /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
      alt: `${title} ${value}`,
      title: value,
      src: image,
      width: 50,
      height: 50
    }) : /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: "Camera",
      width: 29,
      height: 25,
      color: "lightGray"
    }));
  }), hasShowMore && /*#__PURE__*/react.createElement(ShowMoreComponent, {
    show: smoothable || buttonable,
    attributesLength: attribute.values.length - (minLength - 1),
    style: style,
    onClick: showTitle ? handleOnClick : onChange
  }));
};

AttributeColor.defaultProps = {
  attribute: {},
  disabled: false,
  variations: [],
  title: '',
  alignment: '',
  minLength: 5,
  variant: 'smooth',
  showTitle: true,
  onVariationClick: null,
  style: {
    width: '70px',
    height: '70px',
    bg: 'background.base',
    fontWeight: 'bold',
    color: 'text.base'
  }
};
 false ? 0 : void 0;
/* harmony default export */ var attribute_color = (AttributeColor);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeColor/index.js


/***/ }),

/***/ 7069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ attribute_radio; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeRadio/attribute-radio.styles.js


const Input = styled_components_browser_esm/* default.input */.ZP.input`
  display: none;

  &:checked ~ label {
    background-color: ${(0,esm/* getBackgroundColor */.dF)('primary')};
    border-color: ${(0,esm/* getBackgroundColor */.dF)('primary')};
    color: ${(0,esm/* getTextColor */.uu)('white')};
    cursor: default;
  }

  &:disabled ~ label {
    background-color: ${(0,esm/* getBackgroundColor */.dF)('white')};
    color: ${(0,esm/* getTextColor */.uu)('light')};
    cursor: not-allowed;

    img {
      filter: grayscale(1);
      opacity: 0.2;
    }
  }

  &[name='color'] {
    & ~ label {
      background-color: ${(0,esm/* getBackgroundColor */.dF)('white')};
      height: ${({
  height
}) => `${height}`};
      width: ${({
  width
}) => `${width}`};

      & img {
        width: 57px;
        height: 100%;
      }

      &:hover {
        border-color: ${(0,esm/* getBackgroundColor */.dF)('primary')};
      }
    }

    &:checked ~ label {
      border-width: 2px;
    }
  }
`;
const Container = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;
  display: inline-flex;

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    &:first-child {
      margin-left: 0;

      label {
        ${({
  type
}) => type === 'volume' && 'border-top-width: 0px'};
      }
    }
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeRadio/attribute-radio.js







const AttributeRadio = _ref => {
  let {
    checked,
    disabled,
    type,
    value,
    children,
    onChange,
    style,
    path,
    onVariationClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["checked", "disabled", "type", "value", "children", "onChange", "style", "path", "onVariationClick"]);

  return /*#__PURE__*/react.createElement(Container, {
    type: type,
    onClick: e => onVariationClick ? onVariationClick(e, {
      value,
      type,
      path
    }) : null
  }, /*#__PURE__*/react.createElement(Input, (0,esm_extends/* default */.Z)({}, props, {
    "data-testid": "attribute-input",
    type: "radio",
    name: type,
    value: value,
    id: `${type}-${value}`,
    checked: checked,
    disabled: disabled,
    onChange: e => onChange(e, {
      value,
      type
    }),
    height: (style == null ? void 0 : style.height) || '70px',
    width: (style == null ? void 0 : style.width) || '70px'
  })), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    as: "label",
    "data-testid": "attribute-item",
    borderWidth: 1,
    borderColor: "whisper",
    borderStyle: "solid",
    borderRadius: "default",
    padding: 2,
    color: "text.base",
    fontSize: 2,
    fontWeight: "medium",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    htmlFor: `${type}-${value}`
  }, children));
};

 false ? 0 : void 0;
/* harmony default export */ var attribute_radio = (AttributeRadio);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeRadio/index.js


/***/ }),

/***/ 2575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ attribute_volume; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeBase/index.js + 2 modules
var AttributeBase = __webpack_require__(34014);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/getVariation.js
var getVariation = __webpack_require__(98047);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeRadio/index.js + 2 modules
var AttributeRadio = __webpack_require__(7069);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeSelect/attribute-select.styles.js







const Overlay = styled_components_browser_esm/* default.div */.ZP.div`
  background-color: rgba(0, 0, 0, 0.63);
  animation: ${utils/* fadeIn */.Ji} 0.3s linear;
  -webkit-overflow-scrolling: touch;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    display: none;
  }
`;
const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: ${(0,esm/* themeGet */.R)('zIndices.2')};
  justify-content: flex-end;

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    z-index: ${(0,esm/* themeGet */.R)('zIndices.0')};
    overflow: hidden;
    position: absolute;
    height: auto;
    top: 56px;
    bottom: unset;
  }
`;
const Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  width: ${props => props != null && props.fullWidth ? '100%' : '85%'};
  overflow: hidden;
  flex-direction: column;
  animation: ${utils/* slideFromBottom */.$7} 0.3s ease-in-out;
  z-index: ${(0,esm/* themeGet */.R)('zIndices.1')};

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    width: 100%;
    position: relative;
    animation: ${utils/* slideFromTop */.ie} 0.3s ease-in-out;
  }
`;
const Paper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  background-color: ${(0,esm/* getBackgroundColor */.dF)('white')};
  position: relative;
  max-height: 250px;
  overflow: hidden;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    border-radius: 6px;
    border: 1px solid;
    border-color: ${(0,esm/* getBorderColor */.kJ)('light')};
  }
`;
const Header = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  justify-content: ${props => props.hasContentLabel ? 'space-between' : 'flex-end'};
  align-items: center;
  background-color: ${(0,esm/* getBackgroundColor */.dF)('base')};
  height: 47px;
  font-size: 20px;
  font-weight: 500;
  color: #515151;
  padding: 0 12px;
  line-height: 39px;

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    display: none;
  }
`;
const Body = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  flex-direction: column;
  padding-bottom: 44px;
  overflow-y: auto;
  height: calc(100% - 39px);

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    padding-top: 0;
    padding-bottom: 0;
    height: 100%;
    max-height: 250px;
  }
`;
const Footer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 5%, rgba(255, 255, 255, 1) 45%);
  position: absolute;
  width: 100%;
  height: 46px;
  bottom: 0;

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    display: none;
  }
`;
const CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* Close */.x8P).attrs(props => ({
  color: (0,esm/* getTextColor */.uu)('primary')(props)
}))`
  ${(0,esm/* getMediaQuery */.aK)('large')} {
    display: none;
  }
`;
const Option = (0,styled_components_browser_esm/* default */.ZP)(AttributeRadio/* default */.Z)`
  & ~ label {
    width: 100%;
    height: 46px;
    border: 0px;
    padding: 0 12px;
    border-radius: 0px;
    border-top-width: 1px;
    border-style: solid;
    border-color: ${(0,esm/* getBorderColor */.kJ)('light')};
    color: ${(0,esm/* getTextColor */.uu)('light')};
    justify-content: space-between;
    font-weight: normal;
    line-height: 22px;
  }

  &:checked ~ label {
    background-color: transparent;
    background-color: ${(0,esm/* getBackgroundColor */.dF)('opacityBlue')};
    border-color: ${(0,esm/* getBorderColor */.kJ)('light')};
    font-weight: 500;
    color: ${(0,esm/* getTextColor */.uu)('base')};

    &::before {
      content: '';
      width: 5px;
      height: 100%;
      background-color: ${(0,esm/* getBackgroundColor */.dF)('primary')};
      left: 0;
      position: absolute;
    }
  }

  &:disabled ~ label {
    background-color: ${(0,esm/* getBackgroundColor */.dF)('base')};
    color: ${(0,esm/* getTextColor */.uu)('lighter')};
  }

  ${(0,esm/* getMediaQuery */.aK)('large')} {
    &:not(:checked, :disabled) ~ label:hover {
      color: ${(0,esm/* getTextColor */.uu)('primary')};
    }

    &:disabled ~ label {
      cursor: not-allowed;
    }
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeSelect/attribute-select.js





const AttributeSelect = ({
  label,
  values,
  current,
  selected,
  type,
  variations,
  onChange,
  onClose,
  fullWidth
}) => {
  return /*#__PURE__*/react.createElement(Container, null, /*#__PURE__*/react.createElement(Overlay, {
    onClick: onClose
  }), /*#__PURE__*/react.createElement(Wrapper, {
    fullWidth: fullWidth,
    "data-testid": "attribute-list-wrapper"
  }, /*#__PURE__*/react.createElement(Paper, null, /*#__PURE__*/react.createElement(Header, {
    hasContentLabel: !!label
  }, label, /*#__PURE__*/react.createElement(CloseIcon, {
    onClick: onClose,
    "data-testid": "attribute-close"
  })), /*#__PURE__*/react.createElement(Body, null, values == null ? void 0 : values.map((value, index) => {
    const variation = (0,getVariation/* default */.Z)(variations, value);
    return /*#__PURE__*/react.createElement(Option, {
      key: `${value}-${index}`,
      value: value,
      type: type,
      checked: selected && current === value,
      disabled: !(variation != null && variation.isAvailable) && !(variation != null && variation.available),
      onChange: onChange
    }, value);
  })), /*#__PURE__*/react.createElement(Footer, null))));
};

 false ? 0 : void 0;
/* harmony default export */ var attribute_select = (AttributeSelect);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeSelect/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeVolume/attribute-volume.js






const AttributeVolume = ({
  attribute,
  variations,
  onChange,
  alignment,
  fullWidth
}) => {
  const [visible, setVisible] = (0,react.useState)(false);
  const attributes = (0,react.useRef)();
  const handleOnChange = (0,react.useCallback)((e, variation) => {
    onChange(e, variation);
    attributes.current.blur();
  }, [visible]);
  return /*#__PURE__*/react.createElement(AttributeBase/* default */.Z, (0,esm_extends/* default */.Z)({}, attribute, {
    onClick: () => setVisible(!visible),
    onBlur: () => setVisible(false),
    alignment: alignment,
    ref: attributes,
    bordered: true
  }), !!visible && /*#__PURE__*/react.createElement(attribute_select, (0,esm_extends/* default */.Z)({}, attribute, {
    fullWidth: fullWidth,
    variations: variations,
    onChange: handleOnChange,
    onClose: () => setVisible(false)
  })));
};

AttributeVolume.defaultProps = {
  attribute: {},
  disabled: false,
  variations: [],
  alignment: ''
};
 false ? 0 : void 0;
/* harmony default export */ var attribute_volume = (AttributeVolume);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeVolume/index.js


/***/ }),

/***/ 78045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ avatar; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Avatar/avatar.styles.js


const Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs({
  borderRadius: 'circle',
  width: '24px',
  height: '24px',
  overflow: 'hidden'
})``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Avatar/avatar.js








const Avatar = _ref => {
  let {
    src,
    alt,
    fill,
    dataTesteIdImage,
    dataTesteIdIcon,
    iconName
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["src", "alt", "fill", "dataTesteIdImage", "dataTesteIdIcon", "iconName"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "avatar"
  }, props), src ? /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    src: src,
    alt: alt,
    "data-testid": dataTesteIdImage
  }) : /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    fill: fill,
    name: iconName,
    "data-testid": dataTesteIdIcon
  }));
};

 false ? 0 : void 0;
Avatar.defaultProps = {
  src: '',
  alt: '',
  fill: '#2FA0FD',
  iconName: 'UserReviewIcon'
};
/* harmony default export */ var avatar = (Avatar);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Avatar/index.js


/***/ }),

/***/ 96504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ backToTop; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/scrollToTop/index.js
var scrollToTop = __webpack_require__(8719);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/BackToTop/backToTop.styles.js


const BackToTopIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* BackToTop */.zuq)`
  position: fixed;
  width: 63px;
  height: 63px;
  bottom: 75px;
  right: 26px;
  z-index: 99;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/BackToTop/backToTop.js





function BackToTop({
  onClick,
  show
}) {
  const [visible, setVisibility] = (0,react.useState)(show);
  const viewHeight = window && window.innerHeight;

  const scroll = () => {
    (0,scrollToTop/* default */.Z)();
    onClick();
  };

  const checkButtonVisibility = () => {
    const pageOffset = window.pageYOffset;

    if (!visible && pageOffset > viewHeight) {
      setVisibility(true);
    } else if (visible && pageOffset <= viewHeight) {
      setVisibility(false);
    }
  };

  (0,react.useEffect)(() => {
    window.addEventListener('scroll', checkButtonVisibility);
    return () => {
      window.removeEventListener('scroll', checkButtonVisibility);
    };
  }, [visible]);
  return visible ? /*#__PURE__*/react.createElement(BackToTopIcon, {
    "data-testid": "back-to-top",
    onClick: scroll
  }) : /*#__PURE__*/react.createElement(react.Fragment, null);
}

BackToTop.defaultProps = {
  onClick: () => {},
  show: false
};
 false ? 0 : void 0;
BackToTop.displayName = 'BackToTop';
/* harmony default export */ var backToTop = (BackToTop);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/BackToTop/index.js


/***/ }),

/***/ 98460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ badge; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Badge/badge.styles.js


const variations = {
  miniature: styled_components_browser_esm/* css */.iv`
    margin-top: -25px;
    width: 42px;
    height: 32px;
  `,
  list: styled_components_browser_esm/* css */.iv`
    margin-top: -5px;
    width: 50px;
    height: 36px;
  `,
  gallery: styled_components_browser_esm/* css */.iv`
    margin-top: -25px;
    width: 55px;
    height: 40px;
    position: absolute;
    ${(0,esm/* getMediaQuery */.aK)('small')} {
      width: 55px;
      height: 40px;
    }
  `,
  productPage: styled_components_browser_esm/* css */.iv`
    margin-top: 0px;
    width: 55px;
    height: 40px;
  `
};
const Wrapper = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;
  ${({
  displayMode
}) => variations[displayMode] || `margin-top: -25px;`}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Badge/badge.js






const Badges = props => {
  const {
    width,
    height,
    url,
    tooltip
  } = props;
  const newUrl = url && url.replace('{w}', width).replace('{h}', height);
  return url ? /*#__PURE__*/react.createElement(Wrapper, (0,esm_extends/* default */.Z)({}, props, {
    "data-testid": "wrapper-badge"
  }), /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, (0,esm_extends/* default */.Z)({
    src: newUrl,
    alt: tooltip,
    "data-testid": "badge"
  }, props))) : null;
};

 false ? 0 : void 0;
Badges.defaultProps = {
  tooltip: '',
  width: '65',
  height: '50'
};
/* harmony default export */ var badge = (Badges);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Badge/index.js


/***/ }),

/***/ 67619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ breadcrumb; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Breadcrumb/breadcrumb.styles.js



const Wrapper = styled_components_browser_esm/* default.div */.ZP.div`
  background-color: ${props => props.isTransparent ? 'transparent' : (0,esm/* getBackgroundColor */.dF)('lighter')(props)};
`;
const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  position: relative;
  flex: 0;
  flex-basis: auto;
  height: 32px;
  overflow-y: hidden;
  width: max-content;
  direction: rtl;
  background-color: ${props => props.isTransparent ? 'transparent' : (0,esm/* getBackgroundColor */.dF)('lighter')(props)};
`;
const BreadcrumbList = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  align-items: center;
  flex-wrap: nowrap;
  padding: 0 ${props => (0,esm/* themeGet */.R)('space.4')(props)}px 0
    ${props => (0,esm/* themeGet */.R)('space.2')(props)}px;
  direction: ltr;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/index.js + 1 modules
var JsonLD = __webpack_require__(66228);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Breadcrumb/breadcrumb.js








function isActive(count, index) {
  if (index === 1) return false;
  return count === index;
}

const Breadcrumb = ({
  isTransparent,
  items,
  seller,
  onLogoClick,
  onClickItem,
  domain,
  logo
}) => {
  const {
    url = '/',
    icon = 'LogoMagalu',
    title = 'página inicial magalu',
    styles = {
      color: esm/* theme.colors.blue */.rS.colors.blue,
      height: '14px',
      marginTop: '6px',
      width: '60px'
    }
  } = logo || {};
  const firstItem = {
    url,
    icon: /*#__PURE__*/react.createElement(build_esm/* Icon */.JO$, {
      name: icon,
      style: styles
    }),
    title
  };
  firstItem.handleClick = onLogoClick;
  items.forEach(item => Object.assign(item, {
    handleClick: onClickItem
  }));
  const breadcrumbItems = [!seller && firstItem, ...items];
  return /*#__PURE__*/react.createElement(Wrapper, {
    isTransparent: isTransparent
  }, /*#__PURE__*/react.createElement(Container, {
    isTransparent: isTransparent
  }, /*#__PURE__*/react.createElement(BreadcrumbList, null, seller && /*#__PURE__*/react.createElement(atoms/* BreadcrumbItem */.gN, {
    seller: seller
  }), !seller && breadcrumbItems.map((item, index) => /*#__PURE__*/react.createElement(atoms/* BreadcrumbItem */.gN, {
    "data-testid": "breadcrumb-item",
    key: index,
    item: Object.assign({}, item, {
      position: index
    }),
    active: isActive(items.length, index),
    onClick: item.handleClick
  })))), /*#__PURE__*/react.createElement(JsonLD/* default */.ZP, {
    schema: (0,JsonLD/* breadcrumbSchema */.ij)(items, domain),
    type: "BreadcrumbList"
  }));
};

Breadcrumb.defaultProps = {
  isTransparent: false,
  items: [],
  seller: undefined,
  onClickItem: () => {},
  onLogoClick: () => {},
  domain: constants/* MAGALU_DOMAIN */.RW
};
 false ? 0 : void 0;
/* harmony default export */ var breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Breadcrumb/index.js


/***/ }),

/***/ 94296:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CardanAlterButtons/cardan-alter-buttons.styles.js


const CustomBox = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu)`
  display: flex;
  justify-content: end;
  gap: 16px;
  width: ${({
  isRow
}) => isRow ? 'auto' : '100%'};
  flex-direction: ${({
  isRow
}) => isRow ? 'row' : 'column'};
`;
const CustomButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx)`
  height: 48px;
  min-width: 140px;
  border-radius: 12px;
  padding: 12px 16px;
  width: ${({
  isRow
}) => isRow ? 'auto' : '100%'};
  ${({
  border
}) => !border && styled_components_browser_esm/* css */.iv`
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0);
    `}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CardanAlterButtons/cardan-alter-buttons.js






function CardanAlterButtons(_ref) {
  let {
    buttons,
    isRow
  } = _ref,
      containerProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["buttons", "isRow"]);

  return /*#__PURE__*/react.createElement(CustomBox, (0,esm_extends/* default */.Z)({
    "data-testid": "cardan-alter-button-box",
    isRow: isRow
  }, containerProps), buttons.map((button, index) => /*#__PURE__*/react.createElement(CustomButton, {
    key: `button-${button.label}-${index}`,
    onClick: button.onClick,
    border: button.border,
    variation: "outline",
    uppercase: false,
    size: "large",
    isRow: isRow,
    "data-testid": `cardan-alter-button-${index}`
  }, button.label)));
}

const ButtonPropType =  false ? 0 : {};
 false ? 0 : void 0;
CardanAlterButtons.defaultProps = {
  buttons: [{
    label: 'Alterar veículo',
    onClick: () => {}
  }],
  isRow: false
};
/* harmony default export */ var cardan_alter_buttons = ((/* unused pure expression or super */ null && (CardanAlterButtons)));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CardanAlterButtons/index.js


/***/ }),

/***/ 72720:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CardanCarInfo/cardan-car-info.styles.js


const Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Grid */.rj).attrs(containerProps => Object.assign({
  display: 'flex',
  px: 3,
  py: '10px',
  backgroundColor: 'background.lighter',
  border: '1px solid #B8C1C4',
  borderRadius: '8px'
}, containerProps))`
  width: 100%;
  gap: 14px;
  grid-template-columns: minmax(auto, 42px) auto;
  grid-template-areas: 'f c';
`;
const InfoContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  flex-direction: column;
  justify-content: space-around;
  grid-area: c;
`;
const FigureContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(props => Object.assign({
  mr: 2,
  height: '32px'
}, props))`
  grid-area: f;
`;
const BrandFigure = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Image */.Ee)``;
const InfoText = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(props => Object.assign({
  forwardedAs: 'p',
  color: 'text.base',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '16px'
}, props))``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CardanCarInfo/cardan-car-info.js






const CardanCarInfo = _ref => {
  let {
    text,
    alt,
    imageUrl
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["text", "alt", "imageUrl"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "car-info-container"
  }, props), /*#__PURE__*/react.createElement(FigureContainer, {
    "data-testid": "info-figure-container"
  }, /*#__PURE__*/react.createElement(BrandFigure, {
    src: imageUrl,
    alt: alt,
    width: 64,
    height: 64,
    lazy: true
  })), /*#__PURE__*/react.createElement(InfoContainer, {
    "data-testid": "info-container"
  }, /*#__PURE__*/react.createElement(InfoText, {
    "data-testid": "info-text"
  }, text)));
};

 false ? 0 : void 0;
CardanCarInfo.defaultProps = {
  text: '',
  imageUrl: undefined,
  alt: ''
};
/* harmony default export */ var cardan_car_info = ((/* unused pure expression or super */ null && (CardanCarInfo)));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CardanCarInfo/index.js


/***/ }),

/***/ 49542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ carousel; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react-swipeable/es/index.js
var es = __webpack_require__(28249);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/reducer.js
function previous(indicators, current, slidesPerView) {
  const length = indicators * slidesPerView;
  return (current - slidesPerView + length) % length;
}

function next(indicators, current, slidesPerView) {
  const length = indicators * slidesPerView;
  return (current + slidesPerView) % length;
}

const getNewIndex = ({
  direction,
  slides,
  slideIndex,
  showSlideCount,
  infinity
}) => {
  const increment = direction === 'next' ? 1 : -1;
  let newIndex = slideIndex + increment;
  const length = slides == null ? void 0 : slides.length;

  if (infinity) {
    newIndex = (newIndex + length) % length;
  }

  return showSlideCount ? Math.min(Math.max(newIndex, 0), length - 1) : newIndex;
};
const getSiblings = ({
  lazy = false,
  length = 0,
  slidesPerView = 1,
  active = 0
} = {}) => {
  const items = Array.from(Array(length).keys());
  if (!lazy) return items;
  const pages = Math.ceil(length / slidesPerView);
  const lastPageLength = length % slidesPerView || slidesPerView;
  const currentPage = Math.ceil((active + 1) / slidesPerView);
  let nextPage = currentPage + 1;
  if (nextPage > pages) nextPage = 1;
  let prevPage = currentPage - 1;
  if (prevPage < 1) prevPage = pages;

  const getPages = page => {
    const start = page * slidesPerView - slidesPerView;
    const end = page === pages ? start + lastPageLength : start + slidesPerView;
    return items.slice(start, end);
  };

  return [...getPages(prevPage), ...getPages(currentPage), ...getPages(nextPage)].sort();
};
function carouselReducer(state, action) {
  switch (action.type) {
    case 'jump':
      return Object.assign({}, state, {
        desired: action.desired * action.slidesPerView
      });

    case 'next':
      return Object.assign({}, state, {
        desired: next(action.indicators, state.active, action.slidesPerView)
      });

    case 'prev':
      return Object.assign({}, state, {
        desired: previous(action.indicators, state.active, action.slidesPerView)
      });

    case 'done':
      return Object.assign({}, state, {
        offset: NaN,
        active: state.desired,
        visible: action.lazy ? Array.from(new Set([...state.visible, ...getSiblings(Object.assign({}, action, {
          active: state.desired
        }))])) : state.visible
      });

    case 'drag':
      return Object.assign({}, state, {
        offset: action.offset
      });

    default:
      return state;
  }
}
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/useCarousel.js




function threshold(target) {
  const width = target.clientWidth;
  return width / 5;
}

const initialCarouselState = {
  offset: 0,
  desired: 0,
  active: 0
};

function swiped(e, dispatch, indicators, dir, slidesPerView) {
  const t = threshold(e.event.target);
  const d = dir * -e.deltaX;

  if (d >= t) {
    dispatch({
      type: dir > 0 ? 'next' : 'prev',
      indicators,
      slidesPerView
    });
  } else {
    dispatch({
      type: 'drag',
      offset: 0
    });
  }
}

const calcPageWidth = (length, slidesPerView, showPartial) => {
  // partial shows 1/3 max 10% of page
  const pageWidth = 100;
  let parcialWidth = 100 / slidesPerView / 3;

  if (parcialWidth > 10) {
    parcialWidth = 10;
  }

  return showPartial && length > 1 ? pageWidth - parcialWidth : pageWidth;
};
function useCarousel({
  length,
  interval,
  transitionDuration,
  auto,
  slidesPerView,
  showPartial,
  showPartialNextSlide,
  lazy
}) {
  const pageWidth = calcPageWidth(length, slidesPerView, showPartial || showPartialNextSlide);
  const cardWidth = `${pageWidth / slidesPerView}%`;
  const indicators = Math.ceil(length / slidesPerView);
  const smooth = `transform ${transitionDuration}ms ease`;
  const [state, dispatch] = (0,react.useReducer)(carouselReducer, Object.assign({}, initialCarouselState, {
    visible: getSiblings({
      lazy,
      length,
      active: 0,
      slidesPerView
    })
  }));
  const handlers = (0,es/* useSwipeable */.QS)({
    onSwiping(e) {
      dispatch({
        type: 'drag',
        offset: e.deltaX
      });
    },

    onSwipedLeft(e) {
      swiped(e, dispatch, indicators, 1, slidesPerView);
    },

    onSwipedRight(e) {
      swiped(e, dispatch, indicators, -1, slidesPerView);
    },

    trackMouse: false,
    trackTouch: true
  });
  (0,react.useEffect)(() => {
    const id = auto && setTimeout(() => dispatch({
      type: 'next',
      indicators,
      slidesPerView
    }), interval);
    return () => clearTimeout(id);
  }, [auto, state.offset, state.active]);
  (0,react.useEffect)(() => {
    const id = setTimeout(() => dispatch({
      type: 'done',
      lazy,
      length,
      slidesPerView
    }), transitionDuration);
    return () => clearTimeout(id);
  }, [state.desired]);
  const partialSize = showPartial ? (100 - pageWidth) / 2 : 0;
  const partialPrev = state.active !== 0 ? partialSize : 0;
  const style = {
    transform: 'translateX(0)',
    width: `${pageWidth * (length / slidesPerView)}%`,
    left: `-${state.active * (pageWidth / slidesPerView) - partialPrev}%`
  };

  if (state.desired !== state.active) {
    const dist = Math.abs(state.active - state.desired) / slidesPerView;
    const pref = Math.sign(state.offset || 0);
    const dir = -1 * Math.sign(state.desired - state.active);
    const shift = 100 * (pref || dir) / (length / slidesPerView) * dist;
    let shiftCompensation = 0;

    if (state.active === 0) {
      shiftCompensation = partialSize / length / slidesPerView;
    }

    if (state.desired === 0) {
      shiftCompensation = partialSize / (length / slidesPerView) * -1;
    }

    style.transition = smooth;
    style.transform = `translateX(${shift + shiftCompensation}%)`;
  } else if (!Number.isNaN(state.offset)) {
    style.transform = `translateX(${state.offset}px)`;
  }

  return {
    active: state.active,
    setActive: n => dispatch({
      type: 'jump',
      desired: n,
      slidesPerView
    }),
    handlers,
    style,
    cardWidth,
    indicators,
    visible: state.visible
  };
}
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/BaseButton/base-button.styles.js
var base_button_styles = __webpack_require__(59120);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/carousel.styles.js







const baseArrowsAttrs = {
  color: 'primary.base',
  width: 40,
  height: 40
};
const Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  position: relative;
  overflow: hidden;
`;
const CarouselContent = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
  position: relative;

  ${({
  showControls
}) => showControls && styled_components_browser_esm/* css */.iv`
      padding-bottom: ${props => props.insideControls ? '0' : '25'}px;
    `};

  max-height: ${({
  itemHeight
}) => itemHeight ? `${itemHeight}px` : null};
`;
const CarouselItem = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(({
  gutter,
  alignContent
}) => ({
  pr: gutter ? `${gutter}px` : null,
  va: alignContent ? `${alignContent}` : null
}))`
  width: ${({
  width = '50%'
}) => width};
  &:first-child {
    padding-left: ${({
  gutter
}) => gutter ? `${gutter}px` : null};
  }
  transition: box-shadow 0.4s ease 0s;
  align-content: ${({
  alignContent = null
}) => alignContent};
`;
const CarouselContainer = styled_components_browser_esm/* default.div */.ZP.div`
  overflow: hidden;

  ${({
  showArrowControls
}) => showArrowControls && styled_components_browser_esm/* css */.iv`
      margin: ${props => props.insideControls ? '0px' : '0px 40px'};
    `};
`;
const ArrowsControlsButton = styled_components_browser_esm/* default.button */.ZP.button`
  ${base_button_styles/* BaseButtonStyle */.z}

  background: rgba(255, 255, 255, 0.5);
  width: fit-content;
  height: fit-content;
  position: absolute;
  top: calc((100% - 40px) / 2);
  cursor: ${({
  disabled
}) => disabled ? 'default' : 'pointer'};

  ${props => props.left && styled_components_browser_esm/* css */.iv`
      left: 0;
    `}

  ${props => props.right && styled_components_browser_esm/* css */.iv`
      right: 0;
    `}
  
  ${props => props.insideControls && styled_components_browser_esm/* css */.iv`
      z-index: 2;
    `}

  ${index_esm/* shadow */.AF}
  ${esm/* color */.$_}
`;
const PrevIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* ChevronLeft */.s$$).attrs(props => Object.assign({}, baseArrowsAttrs, props))`
  ${esm/* color */.$_}
`;
const NextIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* ChevronRight */._Qn).attrs(props => Object.assign({}, baseArrowsAttrs, props))`
  ${esm/* color */.$_}
`;
const CarouselIndicators = styled_components_browser_esm/* default.ol */.ZP.ol`
  position: absolute;
  right: 0;
  bottom: ${props => props.insideControls ? (0,esm/* themeGet */.R)('space.3')(props) : 0}px;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding-left: 0;
  list-style: none;
  margin: auto;
`;
const CarouselIndicator = styled_components_browser_esm/* default.li */.ZP.li`
  position: relative;
  flex: 0 1 auto;
  width: 8px;
  height: 8px;
  margin: 0 0.3em;
  cursor: pointer;
  border: solid 1.2px;
  border-radius: 4px;

  ${props => {
  return props.active ? `
        background: ${(0,esm/* getPaletteColor */.ow)('text.scratched')(props)};
        border-color: ${(0,esm/* getPaletteColor */.ow)('text.scratched')(props)};
      ` : `
        background: ${(0,esm/* getPaletteColor */.ow)('background.lighter')(props)};
        border-color: ${(0,esm/* getPaletteColor */.ow)('text.scratched')(props)};
      `;
}}

  ${(0,esm/* getMediaQuery */.aK)('small')} {
    width: 10px;
    height: 10px;
    border-radius: 8px;
  }
`;
const SlideCount = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  margin-top: 10px;
  color: #697277;
  display: flex;
  justify-content: center;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/carousel.js








const Carousel = _ref => {
  let {
    children,
    slidesPerView,
    showPartial,
    showPartialNextSlide,
    interval,
    transitionDuration,
    auto,
    showArrowControls,
    showControls,
    showSlideCount,
    infinity,
    insideControls,
    onChange,
    gutter,
    itemHeight,
    isProductCarousel,
    lazy,
    goTo,
    verticalAlign
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "slidesPerView", "showPartial", "showPartialNextSlide", "interval", "transitionDuration", "auto", "showArrowControls", "showControls", "showSlideCount", "infinity", "insideControls", "onChange", "gutter", "itemHeight", "isProductCarousel", "lazy", "goTo", "verticalAlign"]);

  const slides = react.Children.toArray(children);
  const length = slides == null ? void 0 : slides.length;
  const numActive = Math.min(length, slidesPerView);
  const {
    handlers,
    style,
    cardWidth,
    indicators,
    setActive,
    active,
    visible
  } = useCarousel({
    length,
    interval,
    transitionDuration,
    auto,
    slidesPerView: numActive,
    showPartial,
    showPartialNextSlide,
    lazy
  });
  const [slideIndex, setSlideIndex] = (0,react.useState)(0);
  (0,react.useEffect)(() => {
    setSlideIndex(goTo);
    setActive(goTo);
  }, [goTo]);
  (0,react.useEffect)(() => {
    onChange(active);
  }, [active]);
  return length > 1 ? /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "carousel"
  }, props), showArrowControls && /*#__PURE__*/react.createElement(ArrowsControlsButton, {
    "data-testid": "arrow-previous-button",
    "aria-label": "Ver elemento da esquerda",
    disabled: !infinity && slideIndex - 1 < 0,
    left: true,
    insideControls: insideControls,
    onClick: () => {
      const newIndex = getNewIndex({
        direction: 'previous',
        slides,
        slideIndex,
        showSlideCount,
        infinity
      });
      setSlideIndex(newIndex);
      setActive(newIndex);
    }
  }, /*#__PURE__*/react.createElement(PrevIcon, null)), /*#__PURE__*/react.createElement(CarouselContainer, {
    showArrowControls: showArrowControls,
    insideControls: insideControls
  }, /*#__PURE__*/react.createElement(CarouselContent, (0,esm_extends/* default */.Z)({
    showControls: showControls,
    showSlideCount: showSlideCount,
    insideControls: insideControls,
    itemHeight: itemHeight
  }, handlers, {
    style: style
  }), slides.map((slide, index) => /*#__PURE__*/react.createElement(CarouselItem, {
    "data-testid": "carousel-item",
    width: cardWidth,
    isProductCarousel: isProductCarousel,
    gutter: showPartial || showPartialNextSlide || slidesPerView > 1 ? gutter : 0,
    alignContent: verticalAlign,
    index: index,
    key: `carousel-item-${slides.length}-${index + 1}`
  }, visible.includes(index) && slide))), showControls && slides.length > numActive && /*#__PURE__*/react.createElement(CarouselIndicators, {
    insideControls: insideControls,
    "data-testid": "carousel-indicators"
  }, Array(indicators).fill().map((slide, index) => /*#__PURE__*/react.createElement(CarouselIndicator, {
    "data-testid": "carousel-indicator",
    active: active / slidesPerView === index,
    onClick: () => {
      setActive(index);
      setSlideIndex(index);
    },
    key: `carousel-indicator-${slides.length}-${index + 1}`
  }))), showSlideCount && /*#__PURE__*/react.createElement(SlideCount, {
    "data-testid": "slide-count"
  }, Math.min(slideIndex + 1, length), " / ", length)), showArrowControls && /*#__PURE__*/react.createElement(ArrowsControlsButton, {
    "data-testid": "arrow-next-button",
    "aria-label": "Ver elemento da direita",
    disabled: !infinity && slideIndex + 1 === indicators,
    insideControls: insideControls,
    onClick: () => {
      const newIndex = getNewIndex({
        direction: 'next',
        slides,
        slideIndex,
        showSlideCount,
        infinity
      });
      setSlideIndex(newIndex);
      setActive(newIndex);
    },
    right: true
  }, /*#__PURE__*/react.createElement(NextIcon, null))) : children;
};

Carousel.defaultProps = {
  slidesPerView: 1,
  showPartial: false,
  showPartialNextSlide: false,
  interval: 500,
  transitionDuration: 400,
  auto: true,
  showArrowControls: false,
  showControls: true,
  showSlideCount: false,
  onChange: () => {},
  gutter: 4,
  infinity: false,
  isProductCarousel: false,
  insideControls: false,
  lazy: false,
  goTo: 0,
  verticalAlign: ''
};
 false ? 0 : void 0;
Carousel.CarouselItem = CarouselItem;
/* harmony default export */ var carousel = (Carousel);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/index.js


/***/ }),

/***/ 2761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Confirm_confirm; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ConfirmButton/index.js + 1 modules
var ConfirmButton = __webpack_require__(58331);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Confirm/confirm.js




const defaultColor = 'icons.disabled';
const Confirm = /*#__PURE__*/(0,react.forwardRef)(({
  value,
  onChange
}, ref) => {
  const [colorLike, setColorLike] = (0,react.useState)(defaultColor);
  const [colorDislike, setColorDislike] = (0,react.useState)(defaultColor);
  (0,react.useEffect)(() => {
    setColorLike(value === 'like' ? 'icons.like' : defaultColor);
    setColorDislike(value === 'dislike' ? 'icons.dislike' : defaultColor);
    return () => {
      setColorLike(defaultColor);
      setColorDislike(defaultColor);
    };
  }, [value]);
  return /*#__PURE__*/react.createElement(Grid/* default */.Z, {
    ref: ref,
    gridTemplateColumns: "1fr 1fr",
    gap: 30
  }, /*#__PURE__*/react.createElement(ConfirmButton/* default */.Z, {
    type: "like",
    label: "Sim",
    color: colorLike,
    onClick: () => {
      setColorDislike(defaultColor);
      onChange({
        target: {
          value: 'like'
        }
      });
    },
    onMouseOver: () => setColorLike('icons.like'),
    onMouseLeave: () => setColorLike(color => value === 'like' ? color : defaultColor),
    "data-testid": "btn-like"
  }), /*#__PURE__*/react.createElement(ConfirmButton/* default */.Z, {
    type: "dislike",
    label: "N\xE3o",
    color: colorDislike,
    onClick: () => {
      setColorLike(defaultColor);
      onChange({
        target: {
          value: 'dislike'
        }
      });
    },
    onMouseOver: () => setColorDislike('icons.dislike'),
    onMouseLeave: () => setColorDislike(color => value === 'dislike' ? color : defaultColor),
    "data-testid": "btn-dislike"
  }));
});
 false ? 0 : void 0;
Confirm.displayName = 'Confirm';
/* harmony default export */ var Confirm_confirm = (Confirm);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Confirm/index.js


/***/ }),

/***/ 12241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ copy_to_clipboard; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CopyToClipboard/copy-to-clipboard.styles.js




const StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
  height: 52px;
`;
const StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)`
  align-items: center;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  display: flex;
  flex-direction: column;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  height: 52px;
  min-width: 64px;
  padding: ${props => (0,build_esm/* themeGet */.R)('space.1')(props)}px;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CopyToClipboard/copy-to-clipboard.js









function CopyToClipboard(_ref) {
  let {
    value
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["value"]);

  const {
    color,
    'data-testid': dataTestId,
    disabled,
    uppercase,
    variation,
    delay
  } = props,
        inputProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["color", "data-testid", "disabled", "uppercase", "variation", "delay"]);

  const [isActive, setIsActive] = (0,react.useState)(false);
  const [isDisabled, setIsDisabled] = (0,react.useState)(disabled);

  const handleCopyToClipboard = link => {
    setIsActive(true);
    setIsDisabled(true);
    (0,utils/* copyToClipboard */.vQ)(link);
    return setTimeout(() => {
      setIsActive(false);
      setIsDisabled(false);
    }, delay);
  };

  return /*#__PURE__*/react.createElement(Flex/* default */.Z, null, /*#__PURE__*/react.createElement(StyledInput, (0,esm_extends/* default */.Z)({
    "data-testid": `${dataTestId}-input`,
    readOnly: true,
    value: value
  }, inputProps)), /*#__PURE__*/react.createElement(StyledButton, {
    color: color,
    "data-testid": `${dataTestId}-button`,
    disabled: isDisabled,
    onClick: () => handleCopyToClipboard(value),
    startIcon: /*#__PURE__*/react.createElement(esm/* Copy */.CKM, {
      width: 25,
      height: 21
    }),
    uppercase: uppercase,
    variation: variation
  }, isActive ? 'Copiado' : 'Copiar'));
}

CopyToClipboard.defaultProps = {
  color: 'primary',
  'data-testid': 'copy-to-clipboard',
  delay: 3000,
  disabled: false,
  uppercase: false,
  value: '',
  variation: 'fill'
};
 false ? 0 : void 0;
CopyToClipboard.displayName = 'CopyToClipboard';
/* harmony default export */ var copy_to_clipboard = (CopyToClipboard);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CopyToClipboard/index.js


/***/ }),

/***/ 84022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ counter; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Counter/counter.styles.js



const Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)``;
const Counter = styled_components_browser_esm/* default.span */.ZP.span`
  background-color: ${props => props.color || (0,esm/* getBackgroundColor */.dF)('primary')(props)};
  border-radius: 50%;
  color: ${props => (0,esm/* getTextColor */.uu)('lightest')(props)};
  min-width: ${props => (0,esm/* themeGet */.R)('space.3')(props)}px;
  min-height: ${props => (0,esm/* themeGet */.R)('space.3')(props)}px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Counter/counter.js





const counter_Counter = _ref => {
  let {
    count
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["count"]);

  return /*#__PURE__*/react.createElement(react.Fragment, null, count >= 1 && /*#__PURE__*/react.createElement(Wrapper, props, /*#__PURE__*/react.createElement(Counter, props, count)));
};

 false ? 0 : void 0;
counter_Counter.defaultProps = {
  count: 0
};
/* harmony default export */ var counter = (counter_Counter);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Counter/index.js


/***/ }),

/***/ 57142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ coupon_code_copy; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CouponCodeCopy/coupon-code-copy.styles.js





const CouponCodeContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({}, props, {
  alignItems: 'center'
}))`
  background-color: ${(0,build_esm/* getBackgroundColor */.dF)('limeGreen')};
  border-radius: 8px;
  height: 40px;
  padding: 6px;
  width: 100%;
  margin-bottom: 12px;
`;
const CouponCodeLabel = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({
  alignItems: 'center'
}, props))`
  color: ${props => (0,build_esm/* themeGet */.R)('colors.black')(props)};
  flex-shrink: 0;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  padding: 0 6px;
  width: fit-content;

  > strong {
    font-weight: 600;
  }

  > svg {
    margin-right: 4px;
  }
`;
const CouponCodeInputWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  width: 100%;
  position: relative;
`;
const CouponCodeInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z)`
  border: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  color: ${props => (0,build_esm/* themeGet */.R)('colors.darkGray')(props)};
  font-weight: 600;
  height: 28px;
`;
const CouponCodeButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs(props => Object.assign({
  uppercase: false
}, props))`
  align-items: center;
  background-color: ${(0,build_esm/* getBackgroundColor */.dF)('white')};
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  color: ${props => (0,build_esm/* themeGet */.R)('colors.blue')(props)};
  display: flex;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: 600;
  height: 28px;
  min-width: 74px;
  padding: ${props => (0,build_esm/* themeGet */.R)('space.1')(props)}px;

  svg {
    margin-right: 4px;
    fill: ${props => (0,build_esm/* themeGet */.R)('colors.blue')(props)};
  }

  &:hover {
    color: ${props => (0,build_esm/* themeGet */.R)('colors.blue')(props)};
    background-color: ${(0,build_esm/* getBackgroundColor */.dF)('white')};
  }
`;
const CouponCodeCopied = styled_components_browser_esm/* default.div */.ZP.div`
  align-items: center;
  background-color: ${props => (0,build_esm/* themeGet */.R)('colors.deepGreen')(props)};
  border-radius: 4px;
  color: ${props => (0,build_esm/* themeGet */.R)('colors.white')(props)};
  display: flex;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: 600;
  height: 28px;
  justify-content: center;
  opacity: ${({
  isActive
}) => isActive ? 1 : 0};
  pointer-events: ${({
  isActive
}) => isActive ? 'auto' : 'none'};
  position: absolute;
  transition: opacity 0.2s ease-in;
  width: 100%;
  > svg {
    fill: ${props => (0,build_esm/* themeGet */.R)('colors.white')(props)};
    margin-right: 4px;
  }
`;
const CouponCodeAuxiliaryText = styled_components_browser_esm/* default.div */.ZP.div`
  color: ${props => (0,build_esm/* themeGet */.R)('colors.greyishBrown')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CouponCodeCopy/coupon-code-copy.js









const returnCouponLabel = ({
  type,
  value
}) => {
  if (!type || !value) return '';
  return type === 'percentage' ? `${value}% OFF` : `R$ ${value} OFF`;
};

function CouponCodeCopy(_ref) {
  let {
    auxiliaryText,
    code,
    discountType,
    discountValue,
    delay = 3000,
    expirationDate,
    onCopySuccess
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["auxiliaryText", "code", "discountType", "discountValue", "delay", "expirationDate", "onCopySuccess"]);

  const inputProps = Object.assign({}, props);
  const [isActive, setIsActive] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    let timeoutId;

    if (isActive) {
      timeoutId = setTimeout(() => setIsActive(false), delay);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isActive, delay]);

  const handleCouponCodeCopy = async value => {
    const success = await (0,utils/* copyToClipboard */.vQ)(value);

    if (success) {
      setIsActive(true);
      onCopySuccess(value);
    }
  };

  const couponLabel = returnCouponLabel({
    type: discountType,
    value: discountValue
  });
  return /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    "data-testid": "coupon-code-copy"
  }, /*#__PURE__*/react.createElement(CouponCodeContainer, null, /*#__PURE__*/react.createElement(CouponCodeLabel, null, /*#__PURE__*/react.createElement(esm/* LocalActivity */.XVb, {
    width: 16,
    height: 16
  }), " ", /*#__PURE__*/react.createElement("strong", null, couponLabel)), /*#__PURE__*/react.createElement(CouponCodeInputWrapper, null, /*#__PURE__*/react.createElement(CouponCodeInput, (0,esm_extends/* default */.Z)({
    "data-testid": "coupon-code-input",
    readOnly: true,
    value: code
  }, inputProps)), /*#__PURE__*/react.createElement(CouponCodeCopied, {
    "data-testid": "coupon-code-copied",
    isActive: isActive
  }, /*#__PURE__*/react.createElement(esm/* CheckThin */.NGQ, {
    width: 17,
    height: 13
  }), " ", /*#__PURE__*/react.createElement("span", null, "Copiado")), /*#__PURE__*/react.createElement(CouponCodeButton, {
    "data-testid": "coupon-code-button",
    startIcon: /*#__PURE__*/react.createElement(esm/* Copy */.CKM, {
      width: 12,
      height: 14
    }),
    onClick: () => handleCouponCodeCopy(code)
  }, "Copiar"))), /*#__PURE__*/react.createElement(CouponCodeAuxiliaryText, null, auxiliaryText, " ", expirationDate));
}

CouponCodeCopy.defaultProps = {
  auxiliaryText: 'Copie o cupom e aplique na sacola. Válido até',
  code: '',
  discountType: '',
  discountValue: '',
  expirationDate: '',
  onCopySuccess: () => {}
};
 false ? 0 : void 0;
CouponCodeCopy.displayName = 'CouponCodeCopy';
/* harmony default export */ var coupon_code_copy = (CouponCodeCopy);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CouponCodeCopy/index.js


/***/ }),

/***/ 18822:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/DeliveryFilter/delivery-filter.styles.js




const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  display: flex;
  justify-content: ${props => props.carousel ? 'start' : 'center'};
  align-content: center;
  padding: 12px;
  overflow-x: scroll;
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
  display: block;
  margin-bottom: 8px;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
`;
const DeliveryContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const DeliveryItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  scroll-snap-align: center;
  justify-content: center;
  align-items: center;
  padding: 4px 16px;
  line-height: 1.17;
  color: ${props => props.selected ? (0,build_esm/* getTextColor */.uu)('base')(props) : (0,build_esm/* getTextColor */.uu)('lightest')(props)};
  margin-right: 8px;
  background-color: ${props => props.selected ? (0,build_esm/* getBackgroundColor */.dF)('primary')(props) : (0,build_esm/* getBackgroundColor */.dF)('lighter')(props)};
  border-radius: 20px;
  height: 38px;

  > svg {
    margin-right: 4px;
    fill: ${props => props.selected ? (0,build_esm/* getTextColor */.uu)('lightest')(props) : (0,build_esm/* getTextColor */.uu)('base')(props)};
  }
  max-width: 144px;
`;
const Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  width: 81px;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  font-stretch: normal;
  font-style: normal;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.standard')(props)}px;
  letter-spacing: normal;
  height: auto;
  color: ${props => props.selected ? (0,build_esm/* getTextColor */.uu)('lightest')(props) : (0,build_esm/* getTextColor */.uu)('base')(props)};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/DeliveryFilter/delivery-filter.js





function DeliveryOption({
  item,
  onChange
}) {
  const {
    slug,
    label,
    selected
  } = item;

  const renderIcon = icon => {
    const Icons = {
      '24c': esm/* DeliveryRTomorrow */.f9j,
      delivery_plus_1: esm/* FastDelivery */._Ps,
      store_pickup: esm/* PickupStore */.XqY,
      delivery_24h: esm/* Delivery24h */.Ju,
      delivery_1h: esm/* Delivery1h */.Gb7,
      'magalu-entregas': esm/* DeliveryM */.Erv,
      'magalu-partner': esm/* Pin */.lO8,
      today: esm/* ExpressDelivery */.oFb
    };
    const Icon = Icons[icon] || esm/* FastDelivery */._Ps;
    return /*#__PURE__*/react.createElement(Icon, null);
  };

  return /*#__PURE__*/react.createElement(DeliveryItem, {
    onClick: () => onChange(!selected && slug || null),
    selected: selected,
    "data-testid": `opt-${slug}`
  }, renderIcon(slug), /*#__PURE__*/react.createElement(Label, {
    selected: selected
  }, label));
}

DeliveryOption.defaultProps = {
  item: {},
  onChange: null
};
 false ? 0 : void 0;
/**
 * The `<DeliveryFilter />` component used to set filter based on delivery.
 */

function DeliveryFilter({
  data,
  onChange
}) {
  const {
    items
  } = data;

  function handleChange(value) {
    onChange(value && {
      type: 'delivery_magalu',
      value
    });
  }

  return /*#__PURE__*/react.createElement(Container, {
    carousel: (items == null ? void 0 : items.length) > 2
  }, /*#__PURE__*/react.createElement(DeliveryContainer, null, items == null ? void 0 : items.map((item, index) => /*#__PURE__*/react.createElement(DeliveryOption, {
    "data-testid": "filter-option",
    key: `filter-option-${item.slug}-${index}`,
    onChange: handleChange,
    item: item
  }))));
}

DeliveryFilter.defaultProps = {
  onChange: null
};
 false ? 0 : void 0;
/* harmony default export */ var delivery_filter = ((/* unused pure expression or super */ null && (DeliveryFilter)));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/DeliveryFilter/index.js


/***/ }),

/***/ 16618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ dynamic_text; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/DynamicText/dynamic-text.styles.js


const Link = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Link */.rU).attrs(() => ({
  fontSize: 2,
  fontWeight: '900',
  underlineOnHover: true,
  hover: true,
  padding: 0,
  color: 'primary.base'
}))``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/DynamicText/dynamic-text.js






const DynamicText = ({
  data,
  handleClickLink
}) => /*#__PURE__*/react.createElement(react.Fragment, null, data == null ? void 0 : data.map((text, index) => {
  if (typeof text === 'string') return text;
  return text != null && text.href ? /*#__PURE__*/react.createElement(Link, (0,esm_extends/* default */.Z)({
    key: index,
    "data-testid": "dynamic-text-link",
    href: text == null ? void 0 : text.href,
    onClick: e => handleClickLink(e, text)
  }, text), text == null ? void 0 : text.value) : /*#__PURE__*/react.createElement(atoms/* Text */.xv, (0,esm_extends/* default */.Z)({
    key: index
  }, text, {
    as: "span"
  }), text == null ? void 0 : text.value);
}));

DynamicText.defaultProps = {
  data: [],
  handleClickLink: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var dynamic_text = (DynamicText);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/DynamicText/index.js


/***/ }),

/***/ 80001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ faq; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Faq/faq.styles.js


const FaqAccordion = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Accordion */.UQ)`
  div + div:last-child {
    -webkit-line-clamp: unset;
    max-height: 100%;
    ${props => props.open ? `
            max-height: 100%;
          ` : `
            max-height: 0px;
          `}
  }
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/index.js + 1 modules
var JsonLD = __webpack_require__(66228);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Faq/faq.js





const Faq = ({
  faq,
  initialOpen,
  maxQuestions,
  showMoreQuestions,
  showLessQuestions,
  questionAs
}) => {
  const [data, setData] = (0,react.useState)(faq.map(item => Object.assign({}, item, {
    isOpen: initialOpen
  })));
  const [maxItems, setMaxItems] = (0,react.useState)(maxQuestions);

  const toggleShow = i => {
    setData(prev => prev.map((item, index) => i === index ? Object.assign({}, item, {
      isOpen: !item.isOpen
    }) : item));
  };

  const showMore = () => {
    setMaxItems(faq.length);
  };

  const showLess = () => {
    setMaxItems(maxQuestions);
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, data.map((item, index) => /*#__PURE__*/react.createElement(FaqAccordion, {
    "data-testid": 'item-question',
    display: index >= maxItems ? 'none' : 'block',
    key: `faq-accordion-${index}`,
    title: item.question,
    asTitle: questionAs,
    open: item.isOpen,
    onClick: () => {
      toggleShow(index);
    },
    openIcon: "ChevronRight",
    closeIcon: "ChevronUp"
  }, item.answer)), showMoreQuestions && maxItems < data.length && /*#__PURE__*/react.createElement(FaqAccordion, {
    "data-testid": "show-more",
    title: showMoreQuestions,
    open: false,
    onClick: showMore,
    openIcon: "ChevronDown",
    closeIcon: "ChevronDown",
    fontWeight: "100"
  }), showLessQuestions && maxItems === data.length && /*#__PURE__*/react.createElement(FaqAccordion, {
    "data-testid": "show-less",
    title: showLessQuestions,
    open: false,
    onClick: showLess,
    openIcon: "ChevronUp",
    closeIcon: "ChevronUp",
    fontWeight: "100"
  }), /*#__PURE__*/react.createElement(JsonLD/* default */.ZP, {
    schema: (0,JsonLD/* faqSchema */.I1)(data),
    type: "FAQPage"
  }));
};

Faq.defaultProps = {
  questionAs: 'h3',
  faq: [],
  initialOpen: false,
  maxQuestions: undefined,
  showLessQuestions: '',
  showMoreQuestions: ''
};
 false ? 0 : void 0;
/* harmony default export */ var faq = (Faq);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Faq/index.js


/***/ })

}]);